import { Link, RouteComponentProps, useHistory, useLocation, useRouteMatch } from "react-router-dom";
import { QesIcon } from "@app/shared/icons/QESIcon";
import { QesIcons } from "@app/shared/icons/qesIcons";
import Breadcrumbs from "@app/shared/breadcrumbs/Breadcrumbs";
import { Accordion } from "@app/shared/Accordion";
import { AccordionContainer } from "@app/shared/AccordionContainer";
import Page from "@app/shared/Page";
import PageHeader from "@app/shared/PageHeader";
import PageHeaderRight from "@app/shared/PageHeaderRight";
import PageInner from "@app/shared/PageInner";
import PageSection from "@app/shared/PageSection";
import { QESButton } from "@app/shared/qes-standards/Button";
import { UserContext, UserContextProps, withUserContext } from "@app/user/UserContext";
import { OutreachExportType } from "@app/network-outreach/export/enumerations";
import { OutreachDataPanelBody } from "@app/network-outreach/export/export-panel-body";
import { FC, useContext } from "react";
import { Location } from "history";

type ExportOutreachDataProps = RouteComponentProps & UserContextProps;

interface RouteState {
  exportType: OutreachExportType
}

const extractRouteState: (location: Location<RouteState>) => RouteState = (location: Location<RouteState>) => {
  const routeState = (location.state || {}) as RouteState;

  return {
    exportType: routeState.exportType
  } as RouteState;
}

const ExportOutreachData: FC = () => {
  const user = useContext(UserContext);
  const history = useHistory();
  const location = useLocation<RouteState>();
  const routeState = extractRouteState(location);
  const routeMatch = useRouteMatch();

  const formatExportType = (newExportType: string) => {
    return newExportType
      .split("-")
      .filter(x => x.length > 0)
      .map((x) => (x.charAt(0).toUpperCase() + x.slice(1)))
      .join(" ");
  }

  const breadcrumbs = ["Network Outreach", "Reports"];

  return (
    <Page documentTitle="Create Downloadable Report - Network Outreach">
      <Breadcrumbs items={breadcrumbs} />
      <PageInner>
        <PageHeader iconName={QesIcons.DownloadCloudV1} title="Create Downloadable Report" disableHR={false}>
          <PageHeaderRight>
            <div className="d-flex">
              <QESButton qesTestId="outreach-export-data_return-to-project" qesType="secondary" onClick={() => history.goBack()} className="me-2">Return to Network Outreach</QESButton>
              <Link to='/reports' className="qes-button qes-button-primary" type="button">Reports</Link>
            </div>
          </PageHeaderRight>
        </PageHeader>

        <PageSection>
          <h3 className="my-4">Outreach Reports</h3>
          <AccordionContainer>
            <Accordion
              defaultOpen={true}
              title={<>{<QesIcon isDecorative iconName={QesIcons.UserV1} width="14" height="16" className="align-baseline me-1" style={{ position: "relative", top: "3px" }} />}{`Outreach Data (${formatExportType(routeState.exportType)})`}</>}
              testId="export-outreach-data__outreach-data-accordion"
            >
              <OutreachDataPanelBody
                onGenerateClick={() => undefined}
                onToastLeave={() => undefined}
                history={history}
                location={location}
                match={routeMatch}
                user={user}
                activeExportType={routeState.exportType} />
            </Accordion>
          </AccordionContainer>
        </PageSection>
      </PageInner>
    </Page>
  );
}

const WrappedExportDataProps = withUserContext(ExportOutreachData);

export {
  WrappedExportDataProps as ExportOutreachData,
  ExportOutreachDataProps,
};